export default __webpack_public_path__ + "static/media/icon_my_sql.9b7bc9a4.svg";